import { service } from '../../../../helpers/http' 

export const ActionGetModuloPlural = ({ dispatch }, payload) => { 
    return service({
        module: 'domainModuloSingular',
        action: 'getModuloPlural',
        payload: payload
    })
}

export const ActionPostModuloPlural = ({ dispatch }, payload) => {

    return service({
        module: 'domainModuloSingular',
        action: 'postModuloPlural',
        payload: payload
    })
    
}

export const ActionPutModuloPlural = ({ dispatch }, payload) => {

    return service({
        module: 'domainModuloSingular',
        action: 'putModuloPlural',
        payload: payload
    })
    
}

export const ActionDeleteModuloPlural = ({ dispatch }, payload) => {

    return service({
        module: 'domainModuloSingular',
        action: 'deleteModuloPlural',
        payload: payload
    })
    
}
